import HeaderComponent from "./HeaderComponent";
import LeagueNameInput from "./LeagueNameInput";
import styles from "./LeagueNameFrame.module.css";

const LeagueNameFrame = () => {
  return (
    <div className={styles.headerComponentWrapper}>
      <HeaderComponent />
    </div>
  );
};

export default LeagueNameFrame;
